<template>
  <div>
    <!-- <pre>{{ payment }}</pre> -->
    <v-switch
      v-model="options.refund"
      :disabled="true || payment.status !== 'succeeded' || loading"
      label="Reembolsar"
    />
    <v-alert v-if="options.refund" color="info" text >
      Por favor, realize o reembolso pelo painel da integração.
    </v-alert>
    <v-switch
      v-model="options.reportAntifraud"
      :disabled="loading"
      label="Reportar ao antifraude"
    />
    
    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between">
      <v-btn :disabled="loading" text @click="$emit('close')"> Cancelar </v-btn>
      <v-btn :loading="loading" color="primary" @click="handleSubmit">
        Reportar
      </v-btn>
    </div>
  </div>
</template>

<script>
import FINANCIAL from "@/services/admin/financial";
export default {
  name: "ChargebackPaymentActions",
  props: {
    payment: Object,
  },
  data() {
    return {
      options: {
        refund: true,
        reportAntifraud: true,
      },
      loading: false,
      error: null,
    };
  },
  methods: {
    async handleSubmit() {
      try {
        this.loading = true;
        this.error = null;
        const response = await FINANCIAL.reportChargeback(
          this.payment.id,
          this.options
        );
        this.$emit("reported", response);
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
